<script>
import { mapGetters } from "vuex";

import dateMixin from "@/mixins/dateMixin";

import Modal from "@/components/_Shared/Modal/Index";
import Tip from "@/components/_base/Tip";

import DatePicker from "../ProfessionalFilters/DatePicker";
import HourPicker from "../ProfessionalFilters/HourPicker";
import DurationPicker from "../ProfessionalFilters/DurationPicker";
import NameInput from "../ProfessionalFilters/NameInput";

export default {
  mixins: [dateMixin],

  components: {
    Modal,
    Tip,
    DatePicker,
    HourPicker,
    DurationPicker,
    NameInput
  },

  data() {
    return {
      filter: "date"
    };
  },

  methods: {
    toogleFilter(filter) {
      this.filter = filter;
    },

    isSelected(filter) {
      return this.filter === filter;
    },

    day() {
      return this.$options.filters.formatDate(this.date, "DD/MM");
    },

    time() {
      return (this.initialHour < 10 ? "0" : "") + `${this.initialHour}h`;
    },

    hours() {
      return `${this.duration} hora` + (this.duration > 1 ? "s" : "");
    }
  },

  computed: {
    ...mapGetters("orderScheduler", [
      "date",
      "initialHour",
      "duration",
      "professionalName"
    ])
  },

  mounted() {
    if (this.professionalName) {
      this.filter = "professional-name";
    }
  }
};
</script>

<template>
  <Modal>
    <template slot="header">
      <div class="filters">
        <div class="dtd">
          <div class="date" @click="toogleFilter('date')" :class="{ selected: isSelected('date')}">
            <img src="/static/calendar-outlined.svg" />
            {{ !date ? "Dia" : day() }}
          </div>

          <div class="time" @click="toogleFilter('time')" :class="{ selected: isSelected('time')}">
            <img src="/static/clock-outlined.svg" />
            {{ !initialHour ? "Hora Inicial" : time() }}
          </div>

            <div class="duration" @click="toogleFilter('duration')" :class="{ selected: isSelected('duration')}">
              <img src="/static/stopwatch-outlined.svg" />
              {{ !duration ? "Duração" : hours() }}
            </div>
        </div>

        <div class="name">
          <div class="professional-name" @click="toogleFilter('professional-name')" :class="{ selected: isSelected('professional-name')}">
            <img src="/static/user-circle-solid.svg" />
            {{ professionalName || 'Nome do Profissional' }}
          </div>
        </div>
      </div>
      <Tip type="alert" size="small">Não é necessário informar todos os campos. Você poderá  escolher o dia hora e duração acessando a agenda do profissional.</Tip>
    </template>

    <template slot="body">
      <div class="picker">
        <DatePicker v-if="filter === 'date'" @dateSelected="toogleFilter('time')" />

        <HourPicker v-if="filter === 'time'" :searchFlow="true" @hourSelected="toogleFilter('duration')" />

        <DurationPicker v-if="filter === 'duration'" :searchFlow="true" />

        <NameInput v-if="filter === 'professional-name'" :searchFlow="true" />
      </div>
    </template>

    <template slot="footer">
      <button class="btn bg-purple" @click="$emit('search')">
        <span>Ver Profissionais Disponíveis</span>
      </button>

      <button class="btn bg-outlined" @click="$emit('endFilterEdition')">
        <span>Voltar</span>
      </button>
    </template>
  </Modal>
</template>

<style scoped>
.filters {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #e2e2e2;
  border-radius: 2px;
  padding: 4px;
  margin-bottom: 8px;
}

.dtd {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.date,
.duration,
.time,
.professional-name {
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  font-size: 14px;
  color: #424242;
  font-weight: 400;
  text-align: center;
  background: #fff;
  border: solid 2px #e2e2e2;
  transition: border-color 250ms ease-in-out;
}

.date,
.duration {
  width: 30%;
}

.time {
  width: 40%;
  margin: 0 2px;
}

.professional-name {
  margin-top: 2px;
  width: 100%;
}

.selected {
  border: solid 2px #603285;
}

.name {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

img {
  height: 16px;
  width: 16px;
  margin-right: 4px;
}

.picker {
  display: flex;
  height: 100%;
}

b {
  font-weight: 400;
  color: #af006b;
}

button {
  margin: 0;
  margin-top: 8px;
}

.bg-outlined {
  padding: 8px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Filters/Filters.vue